import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ImageDisplay {
  isLoading: boolean;
  successful: boolean | undefined;
}

interface InitialState {
  images: Record<string, ImageDisplay> | undefined;
}

const initialState: InitialState = {
  images: undefined,
};

const ImageDisplaySlice = createSlice({
  initialState,
  name: 'imageDisplay',
  reducers: {
    handleImageFailure: (state, action: PayloadAction<string>) => {
      const newObj = { ...state.images };

      newObj[action.payload] = {
        isLoading: false,
        successful: false,
      };

      state.images = newObj;
    },
    handleImageLoading: (state, action: PayloadAction<string>) => {
      const newObj = { ...state.images };

      newObj[action.payload] = {
        isLoading: true,
        successful: undefined,
      };

      state.images = newObj;
    },
    handleImageSuccess: (state, action: PayloadAction<string>) => {
      const newObj = { ...state.images };

      newObj[action.payload] = {
        isLoading: false,
        successful: true,
      };

      state.images = newObj;
    },
    handleImageUnmount: (state) => {
      state.images = undefined;
    },
  },
});

export const {
  handleImageFailure,
  handleImageLoading,
  handleImageSuccess,
  handleImageUnmount,
} = ImageDisplaySlice.actions;

export default ImageDisplaySlice.reducer;
